<template>
<div class="">
  <section class="gb-con-banner">
      <h1>软件正在改变世界</h1>
      <h2>我们帮助技术人和企业了解行业趋势，并应用最新技术</h2>
  </section>
  <section class="gb-con-bl1 gb-con-sec">
    <h2>会议总览</h2>
    <!-- <p class="des-zh">整合全球优质学习资源、帮助技术人和企业成长</p> -->
    <!-- <p chass="des-en">Growing Technicians, Growing Companies</p> -->
    <img class="pc" src="https://static.geekbang.org/infoq/5a4dab52b4330.png">
    <img class="mobile" src="https://static.geekbang.org/infoq/5a4dab5654e27.png">
  </section>
  <section class="gb-con-bl2 gb-con-sec">
    <h2>大会内容价值观</h2>
    <!-- <p>这是BBC的那段翻译 Each time I attend QCon, my mind is opened up to fresh ideas by leaders in their</p> -->
    <ul>
      <li>实践驱动，邀请一线专家</li>
      <li>依据软件技术采用生命周期模型，传播创新技术</li>
      <li>工程师优先于布道师，实践者优先于培训师，团队领导者优先于咨询</li>
      <!-- <li>扎根社区<br>服务社区<br>引领社区</li>
      <li>扎根社区<br>服务社区<br>引领社区</li>
      <li>扎根社区<br>服务社区<br>引领社区</li> -->
    </ul>
  </section>
  <section class="gb-con-bl3 gb-con-sec">
    <h2>传递创新技术企业实战经验</h2>
    <p>将技术采用生命周期中早期应用阶段和早期大多数阶段的技术趋势及应用带回你的团队</p>
    <div class="container row">
      <img src="https://static.geekbang.org/infoq/5a4dad7d7e3db.png?imageView2" alt="">
      <ul>
        <li><i></i>我们关注创新和改变，而非陈词滥调</li>
        <li><i></i>我们关注实践和模式，而非产品介绍。</li>
        <li><i></i>我们关注可落地的想法，而非天马行空。</li>
      </ul>
    </div>
  </section>
  <section class="gb-con-video gb-con-sec">
    <h2>演讲精选</h2>
    <div class="container videos">
      <a href="http://www.infoq.com/cn/presentations/artificial-intelligence-and-software-architecture" target="_blank">
        <div class="video">
          <img src="https://static.geekbang.org/infoq/5a4da547299c4.png" alt="">
        </div>
        <div class="title">
          <span>小米程序化广告交易平台（MAX）的架构实践</span>
        </div>
        <div class="author">
          by <span>欧阳辰</span>
        </div>
      </a>
      <a href="http://www.infoq.com/cn/presentations/artificial-intelligence-and-software-architecture" target="_blank">
        <div class="video">
          <img src="https://static.geekbang.org/infoq/5a4daae2ad708.png" alt="">
        </div>
        <div class="title">
          <span>人工智能与软件架构</span>
        </div>
        <div class="author">
          by <span>黄柳青</span>
        </div>
      </a>
      <a href="http://www.infoq.com/cn/presentations/golang-lua-in-Jingdong-front-end-business-system" target="_blank">
        <div class="video">
          <img src="https://static.geekbang.org/infoq/5a4da6aeda3db.png" alt="">
        </div>
        <div class="title">
          <span>Golang+Lua 在京东前端业务系统中最佳实践</span>
        </div>
        <div class="author">
          by <span>谢刚</span>
        </div>
      </a>
      <a href="http://www.infoq.com/cn/presentations/the-road-of-live-broadcast-of-qq-qzone" target="_blank">
        <div class="video">
          <img src="https://static.geekbang.org/infoq/5a4da5478c173.png" alt="">
        </div>
        <div class="title">
          <span>天下武功唯快不破：QQ 空间直播之路</span>
        </div>
        <div class="author">
          by <span>王磊</span>
        </div>
      </a>
      <a href="http://www.infoq.com/cn/presentations/growth-hacking-recent-developments-and-best-practices" target="_blank">
        <div class="video">
          <img src="https://static.geekbang.org/infoq/5a4da75e89271.png" alt="">
        </div>
        <div class="title">
          <span>Growth Hacking 最新动态和最佳实践</span>
        </div>
        <div class="author">
          by <span>覃超</span>
        </div>
      </a>
      <a href="http://www.infoq.com/cn/presentations/use-apache-helix-to-build-large-scale-distributed-data-cloud-system" target="_blank">
        <div class="video">
          <img src="https://static.geekbang.org/infoq/5a4da54843fa4.png" alt="">
        </div>
        <div class="title">
          <span>利用 Apache Helix 构建高可用和易伸缩的大规模分布式数据云系统</span>
        </div>
        <div class="author">
          by <span>夏磊</span>
        </div>
      </a>
    </div>
  </section>
</div>
</template>

<script>
import ConfVideo from './video'
export default {
  components: {
    ConfVideo
  }
}
</script>

<style lang="sass" scoped>

$color-orange: rgb(230,119,63)
$color-link: #1a5f9f

li
  list-style: none
.gb-con
  line-height: 1.4
.container
  width: 100%
  padding: 0 4vw
.gb-con-nav
  height: 75px
  background-color: white
.gb-con-banner
  height: 495px
  background-color: rgb(230,119,63)
  background-image: url('https://static.geekbang.org/infoq/5a4dad7e2ac6e.png')
  background-size: cover
  background-position: center
  color: #fff
  display: flex
  align-items: center
  align-content: center
  justify-content: center
  flex-wrap: wrap
  text-align: center
  h1, h2
    width: 60vw
  h1
    font-size: 55px
    font-weight: 900
    line-height: 1.2
  h2
    margin-top: 28px
    font-size: 14px
    line-height: 2
    letter-spacing: 2px
.gb-con-sec
  color: #666
  padding-top: 50px
  padding-bottom: 50px
  > h2
    text-align: center
    font-size: 21px
    color: #eb5429
    &::after
      content: ''
      display: block
      width: 25px
      margin: 20px auto
      border-bottom: 1px solid $color-orange
.gb-con-bl1
  text-align: center
  img
    width: 100%
    margin-top: 40px
    &.mobile
      @media screen and (min-width: 769px)
        display: none
    &.pc
      @media screen and (max-width: 768px)
        display: none
.gb-con-bl2
  background-color: rgb(245,245,245)
  background-image: url('https://static.geekbang.org/infoq/5a4dad7db8ec7.png')
  background-size: 200%
  background-position: center bottom
  background-repeat: no-repeat
  text-align: center
  > p
    padding-left: 12vw
    padding-right: 12vw
    font-size: 13px
    letter-spacing: 1px
  ul
    margin-top: 25px
    padding-left: 6vw
    padding-right: 6vw
    display: flex
    justify-content: space-between
    color: white
    li
      display: flex
      justify-content: center
      align-items: center
      align-content: center
      background: $color-orange
      font-size: 12px
      width: 26vw
      height: 26vw
      border-radius: 50%
      opacity: 0.9
      line-height: 1.5
      padding: 0 20px
.gb-con-bl3
  padding-left: 8vw
  padding-right: 8vw
  > p
    font-size: 14px
  ul
    margin-top: 18px
  li
    text-align: left
    font-size: 14px
    line-height: 1.8
    display: flex
    align-items: center
    i
      display: inline-block
      width: 14px
      height: 14px
      background-image: url('./assets/icon-check.png')
      background-position: center
      background-size: contain
      background-repeat: no-repeat
      margin-right: 5px
.gb-con-video
  background-color: rgb(245,245,245)
  .videos
    padding-left: 4vw
    padding-right: 4vw
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    > li, > a
      display: block
      margin-left: 0
      margin-top: 4vw
      width: 44vw
      .video
        position: relative
        width: 100%
        corsor: pointer
        padding: 0 !important
        img
          corsor: pointer
          width: 100%
          vertical-align: text-bottom
        // object, embed, iframe
        //   width: 100%
        //   height: 85px
        //   overflow: hidden
      .title, .author
        font-size: 12px
      .title
        margin-top: 8px
      a
        color: $color-link
        corsor: auto

@media screen and (min-width:679px)
  .container
    width: 1140px
    margin-left: auto
    margin-right: auto
    padding: 0
    position: relative
  .gb-con-banner
    padding-top: 85px
    height: 820px
    h1
      font-size: 100px
      width: 100%
    h2
      margin-top: 30px
      font-size: 20px
  .gb-con-sec
    padding-top: 100px
    padding-bottom: 100px
    > h2
      text-align: center
      font-size: 24px
      color: #eb5429
      &::after
        content: ''
        display: block
        width: 44px
        margin: 30px auto
        border-bottom: 2px solid $color-orange
  .gb-con-bl2
    background-size: 100%
    > p
      font-size: 16px
    ul
      justify-content: center
      padding-top: 60px
      padding-bottom: 60px
      li
        margin-left: 50px
        margin-right: 50px
        line-height: 1.6
        width: 250px
        height: 250px
        font-size: 20px
  .gb-con-bl3
    > p
      font-size: 20px
      text-align: center
    .row
      margin-top: 56px
      display: flex
      justify-content: space-between
    ul
      align-self: flex-end
      padding-bottom: 60px
      li
        line-height: 2.5
        font-size: 20px
        letter-spacing: 2px
        i
          margin-right: 10px
  .gb-con-video
    .videos
      display: flex
      justify-content: space-between
      flex-wrap: wrap
      padding-left: 0
      padding-right: 0
      > li, > a
        margin-top: 25px
        width: 360px
        .video
          display: block
          // height: 190px
          // object, embed
          //   height: 190px
        .author
          font-size: 14px
        .title
          font-size: 16px
          margin-top: 8px
</style>



// WEBPACK FOOTER //
// conf.vue?0c4c583c